export default __webpack_public_path__ + "static/media/vendredi_sur_mer_1.c4de275c.png";